import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-clock-01',
	templateUrl: './icon-clock-01.component.svg',
})
export class IconClock01Component {}
